<template>
  <div class="guarantType">
    <h4>{{$t('records.guarant.type.title')}}</h4>
    <p>{{$t('records.guarant.type.subtitle')}}</p>
    <el-radio-group
      v-model="guarantType"
      class="guarantType__radioGroup"
    >
      <el-radio label="0">
        {{$t('records.guarant.type.radio_yes')}}
      </el-radio>
      <el-radio label="1">
        {{$t('records.guarant.type.radio_no')}}
      </el-radio>
    </el-radio-group>
  </div>
</template>

<script>

export default {
  name: 'GuarantType',
  computed: {
    guarantType: {
      get() {
        return this.$store.getters['recordsPeople/guarantType']
      },
      set(val) {
        this.$store.dispatch('recordsPeople/setGuarantType', val)
      }
    }
  }
}
</script>

<style scoped lang="scss">
$c: '.guarantType';

#{$c} {
  background-color: white;
  padding: 24px;

  & p {
    margin-bottom: 30px;
    margin-top: 0;
  }

  &__radioGroup {
    display: grid;
  }
  &__radioGroup .el-radio:first-child {
    margin-bottom: 20px;
  }
}
</style>